import { TableColumn } from "../table/TableColumn";

const UserFilterColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        translationKey: "name"
    }
];

export default UserFilterColumns;
